import React from 'react'
import { Button } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { getBrowserAdapter } from '@/lib/browserAdapter'

interface SkipToMainContentProps {
    targetId?: string
}

const SkipToMainContent: React.FC<SkipToMainContentProps> = ({ targetId = 'main-content' }) => {
    const { t } = useTranslation()

    const handleSkip = () => {
        const browserAdapter = getBrowserAdapter()
        const element = browserAdapter.getElementById(targetId)
        if (element) {
            element.focus()
            element.scrollIntoView()
        }
    }

    return (
        <Button
            onClick={handleSkip}
            sx={{
                position: 'absolute',
                top: -40,
                left: 6,
                zIndex: 9999,
                backgroundColor: 'primary.main',
                color: 'primary.contrastText',
                '&:focus': {
                    top: 6,
                },
                '&:hover': {
                    backgroundColor: 'primary.dark',
                },
            }}
            aria-label={t('navigation:skipToMain')}
        >
            {t('navigation:skipToMain')}
        </Button>
    )
}

export default SkipToMainContent
